import { useMemo } from 'react';
import { buildStartPointLanguageList } from '@utils/start_point/panelUtils';

function useStartPointLanguages(languages = []) {
  return useMemo(() => buildStartPointLanguageList(languages), [languages]);
}

export default useStartPointLanguages;
